import { Icon } from '@if/mui'
import { Box, Tooltip } from '@mui/material'
import { DEFAULT_PAYMENT_METHOD, EPaymentMethod } from '@src/types/constants'
import { Banknote, Landmark, ReceiptText, Send, type LucideIcon } from 'lucide-react'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

const DEFAULT_PAYMENT_METHOD_ICON = Landmark

const PAYMENT_METHOD_ICONS: Partial<Record<EPaymentMethod, LucideIcon>> = {
  [EPaymentMethod.PreAuthorizedDebit]: Landmark,
  [EPaymentMethod.Cheque]: ReceiptText,
  [EPaymentMethod.Cash]: Banknote,
  [EPaymentMethod.InteracETransfer]: Send,
}

interface Props {
  paymentMode: EPaymentMethod | undefined
}

export const PaymentMethodIconComponent = ({ paymentMode }: Props): ReactNode => {
  const { t } = useTranslation()

  const effectivePaymentMode = paymentMode ?? DEFAULT_PAYMENT_METHOD
  const paymentMethodLabel = t(`enum.EPaymentMethod.${effectivePaymentMode}`)

  return (
    <>
      {paymentMode !== undefined && (
        <Tooltip title={paymentMethodLabel}>
          <Box component="span" sx={{ display: 'inline-flex' }}>
            <Icon
              icon={PAYMENT_METHOD_ICONS[effectivePaymentMode] ?? DEFAULT_PAYMENT_METHOD_ICON}
              size="sm"
              color="action"
            />
          </Box>
        </Tooltip>
      )}
    </>
  )
}
